var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{class:_vm.styleClasses,attrs:{"items":_vm.items,"label":_vm.label,"hint":_vm.hint,"readonly":_vm.readonly,"value":_vm.value,"multiple":_vm.multiple,"rules":_vm.requiredRules},on:{"change":_vm.changeItem,"input":_vm.changeItem}})
}
var staticRenderFns = []

export { render, staticRenderFns }